import { defineComponent, inject, PropType, useSlots } from 'vue';
import { useI18n } from 'vue-i18n';
import { FairplayerButtonVue } from '@/common/primary/button';
import { alertBusKey } from '@/common/domain/alert/AlertBus';
import { globalWindowKey } from '@/common/domain/Window';
import { useRouter } from 'vue-router';
import { loginContextRepositoryKey } from '@/common/domain/login/LoginContextRepository';

const UNHANDLED_USER_AGENT_PARTS = ['instagram', 'facebook'];

export default defineComponent({
  name: 'Login',
  components: { FairplayerButtonVue },

  props: {
    redirectToKyc: {
      type: Boolean as PropType<boolean>,
      required: false,
      default: false,
    },
    expandButton: {
      type: Boolean as PropType<boolean>,
      required: false,
      default: false,
    },
    icon: {
      type: String as PropType<string>,
      required: false,
      default: 'log-in',
    },
    secondaryButton: {
      type: Boolean as PropType<boolean>,
      required: false,
      default: false,
    },
    translateKey: {
      type: String as PropType<string>,
      required: false,
      default: 'homepage.login',
    },
  },

  setup() {
    const { t } = useI18n();
    const router = useRouter();
    const slots = useSlots();

    const alertBus = inject(alertBusKey)!;
    const globalWindow = inject(globalWindowKey)!;
    const loginContextRepository = inject(loginContextRepositoryKey)!;

    const login = () => {
      if (UNHANDLED_USER_AGENT_PARTS.some(userAgentPart => globalWindow.navigator.userAgent?.toLowerCase().includes(userAgentPart))) {
        alertBus.alert({ message: 'errors.login.unhandledBrowser', type: 'warning' });

        return;
      }

      return storeLoginContextThenGoToLogin();
    };

    const storeLoginContextThenGoToLogin = () => {
      loginContextRepository.storeLoginContext({
        redirectUrl: window.location.href,
      });

      return router.push({ name: 'login' });
    };

    return {
      login,
      t,
      slots,
    };
  },
});
